
import { defineComponent } from 'vue';
import GameService from '@/services/GameService';
import TokenService from '@/services/TokenService';
import TransactionService from '@/services/TransactionService';
import ResponseData from '@/_models/ResponseData';
import { Helper } from '@/utils/Helper';

import store from "@/store/index";

export default defineComponent({
  name: "viewDashboard",
  data: function () {
    return {
      games: [],
      tokens: [],
      transactions: [],
      userData: store.getters["auth/user"] ?? "",
      paginationSkip: 0,
      paginationLimit: 5,
      username: "",
      profileSetup: localStorage.getItem("profileSetup") ?? "",
      showLoader: false,
      isAboutDropDown: false,
      walletSetup: localStorage.getItem("walletSetup") ?? "",
      isCloseWalletOnBoard: JSON.parse(sessionStorage.getItem('closeWalletSetupSession')) ?? false,
      currentTab: 'testnet',
    };
  },

  methods: {
    tempCloseWalletSetupOnboard(){
      sessionStorage.setItem("closeWalletSetupSession", "true");
      this.isCloseWalletOnBoard = sessionStorage.getItem("closeWalletSetupSession");
    },
    checkWalletSetup() {
      localStorage.setItem("walletSetup", "1");
      this.walletSetup = '1';
    },
    getDashboardGames() {
      this.showLoader = true;
      if (this.userData !== "") {
        this.username = this.userData.username;
        GameService.getGameListByWalletAddress(this.walletAddress, this.currentTab)
          .then((response: ResponseData) => {
            if (response.status === 200) {
              if (response.data.length > 5) {
                this.games = response.data.slice(0, 5); // Get first 5 games in API fetch (API is in DESC order)
              } else {
                this.games = response.data;
              }

              this.games.forEach(function (game: any) {
                game.newExpiry = Helper.formatDate(game.expiry);
                game.updatedTime = Helper.formatTime(game.updated);
                game.updatedDate = Helper.formatDate(game.updated);
              });
            }else{
              this.games = [];
            }
            this.showLoader = false;
          })
          .catch((error) => {
            this.showLoader = false;
            Helper.endpointErrorHandling(error, "You have not connected your wallet yet.", "warning");
          });
      }
    },

    getDashboardTokens() {
      if (this.userData !== "") {
        TokenService.getTokenListByWalletAddress(this.walletAddress, this.currentTab)
          .then((response: ResponseData) => {
            if (response.status === 200) {
              if (response.data.length > 5) {
                this.tokens = response.data.slice(0, 5);
              } else {
                this.tokens = response.data;
              }

              this.tokens.forEach(function (token: any) {
                token.supply = Helper.convertToCurrency(token.supply);
                token.amount = Helper.convertToCurrency(token.amount);
            });
            }else{
              this.tokens = [];
            }
          })
          .catch((error) => {
            this.showLoader = false;
            // display only once
            // Helper.endpointErrorHandling(error, "You have not connected your wallet yet.", "warning"); 
          });
      }
    },

    getTransactions() {
      if (this.userData !== "") {
        TransactionService.getTransactionsList(this.walletAddress, this.currentTab).then((response: ResponseData) => {
          if (response.status === 200) {
            if (response.data.length > 5) {
              this.transactions = response.data.slice(1).slice(-5);
            } else {
              this.transactions = response.data;
            }

            this.transactions.forEach(function (transaction: any) {
              transaction.newTimeFormat = Helper.formatTime(transaction.created);
              transaction.newDateFormat = Helper.getCurrentYearDifference(transaction.created); //TODO: Update once the date epoch in Web API is updated.
              transaction.newType = TransactionService.getTransactionType(transaction.type);

              if (transaction.assets.length > 0) {
                transaction.assetId = transaction.assets[0].assetID;
                transaction.amount = Helper.convertToCurrency(transaction.assets[0].amount);
              }
            });
          }else{
            this.transactions = [];
          }
        });
      }
    },

    routeEditGame(gameId: string) {
      this.$router.push({
        path: `/update-game/${gameId}`,
      });
    },

    routeEditToken(tokenId: string) {
      this.$router.push({
        path: `/update-token/${tokenId}`,
      });
    },

    goToExplorer(txHash: string){
      if(this.currentTab=='testnet'){
        window.open('https://bctestnetexplorer.xpxsirius.io/#/tx/' + txHash);
      }else{
        window.open('https://explorer.xpxsirius.io/#/tx/' + txHash);
      }
    },

    loadData(){
      this.getDashboardGames();
      this.getDashboardTokens();
      this.getTransactions();
    }
  },

  computed: {
    testnetLabel() {
      return store.getters['config/configTestnetLabel'];
    },
    mainnetLabel() {
      return store.getters['config/configMainnetLabel'];
    },
    walletAddress() {
      return this.currentTab=='testnet'?this.userData.testnetWalletAddress:this.userData.mainnetWalletAddress;
    }
  },

  mounted() {
    this.getDashboardGames();
    this.getDashboardTokens();
    this.getTransactions();
  },
});
